import { render, staticRenderFns } from "./wangxinban.vue?vue&type=template&id=36498d18&scoped=true"
var script = {}
import style0 from "./wangxinban.vue?vue&type=style&index=0&id=36498d18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36498d18",
  null
  
)

export default component.exports